import { render } from "./ScoringSecondDriver.vue?vue&type=template&id=bdfda0b6"
import script from "./ScoringSecondDriver.vue?vue&type=script&lang=js"
export * from "./ScoringSecondDriver.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__